export default {
  student: {},
  studentCards: [],
  billings: [],
  currentBill: {},
  currentBilling: {},
  currentBillingId: null,
  currentContract: {},
  nextUnpaidBill: {},
  overdueBills: [],
  loadingCurrentBill: true,
  notPaidBills: [],
  configs: {},
  currentReenrollment: {},
  institution: {},
};
